import * as types from '../../../actions/actiontypes';

export const getUpdatedTabs = (state, activeTab, count) => {
	let updateTabs = state.tabs.map((tab) => {
		if(tab.id == activeTab){
			tab.value = count
		}

		return tab;
   });

   return updateTabs;
}

export const updatedTabs = (updatedTabs, state) => {

	let tabsCountUpdated = false;

	let updateTabs = state.tabs.map((tab) => {
		let updatedTab = updatedTabs.find((updatedTab) => {
			return updatedTab.id == tab.id && updatedTab.count != tab.value ;
		})

		if(updatedTab){
			tab.value = updatedTab.count;
			tabsCountUpdated = true;
		}
		return tab;
   });

   return tabsCountUpdated ? updateTabs : undefined;
}

const DataReducer = (state, action) => {
	switch (action.type) {
		case 'Active-Tab-Change': {
			let updateTabs = state.tabs;
			if(action.updatedTabs){
				updateTabs = updatedTabs(action.updatedTabs, state);
			}
			return {
				...state,
				activeTab: action.activeTab,
				showViewOption: action.showViewOption,
				dataGroupedBy: action.dataGroupedBy,
				allData: action.allData,
				dataItems: action.dataItems,
				searchValue: action.searchValue,
				tabs: updateTabs ? updateTabs : state.tabs
			};
		}

		case 'Update-Tabs-Value': {
			let updateTabs = state.tabs;

			if(action.updatedTabs){
				updateTabs = updatedTabs(action.updatedTabs, state);
				if(!updateTabs){
					return state;
				}
			}

			return {...state, 
					tabs: updateTabs
				 };
		}

		case 'Set-Search-Value': {
			let updateTabs = state.tabs;

			if(action.updatedTabs){
				updateTabs = updatedTabs(action.updatedTabs, state);
			}

			return {...state, 
					searchValue: !_.isUndefined(action.searchValue)  ? action.searchValue : state.searchValue,
					dataItems: action.dataItems,
					tabs: updateTabs ? updateTabs : state.tabs,
					allData: action.allData ? action.allData : state.allData
				 };
		}		

		case 'Set-View-Type': {
			let updateTabs = state.tabs;
			if(action.updatedTabs){
				updateTabs = updatedTabs(action.updatedTabs, state);
			}
			return {...state, 
						viewByVisible: action.viewByVisible != undefined ? action.viewByVisible : state.viewByVisible , 
						dataGroupedBy : action.dataGroupedBy,
						dataItems: action.dataItems,
						tabs: updateTabs ? updateTabs : state.tabs,
						searchValue: !_.isUndefined(action.searchValue)  ? action.searchValue : state.searchValue
					};
		}

		case 'Set-View-By-Visible': {
			return {...state, viewByVisible : action.viewByVisible };
		}

		case 'Set-Available-Data': {
			return {...state, allData : action.allData, dataItems: action.dataItems };
		}

		case 'Update-Render-Key': {
			return {...state,
					componentRenderKey : new Date().toString() 
				};
			break;

		}
		
		default:
			return state;
	}
};

export default DataReducer;
